// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d1bdde73","703":"ee6944ca"}[chunkId] + ".chunk.js";
};